<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
  .u-mt-md
    .wordCounter
      .grid
        .column.is-tablet-8
          .wordCounter-header
            .u-mb-xs #[span {{$t('characters')}}]  #[b {{textInput.length}}]
            .u-mb-xs #[span {{$t('words')}}]  #[b {{words ? words.length : 0}}]
            .u-mb-xs #[span {{$t('sentences')}}]  #[b {{textInput.split('.').filter(n => n != false).length}}]
            .u-mb-xs #[span {{$t('whiteSpaces')}}]  #[b {{textInput.split(' ').length - 1}}]
            .u-mb-xs #[span {{$t('paragraphs')}}]  #[b {{paragraphs.length}}]
            .u-mb-xs #[span {{$t('readingTime')}}]  #[b {{words ? Math.ceil((60 * words.length) / 220) : 0}} s]
            .u-mb-xs #[span {{$t('facebook')}}]  #[b {{250 - textInput.length}} / 250]
            .u-mb-xs #[span {{$t('twitter')}}]  #[b {{280 - textInput.length}} / 280]
          textarea.input.is-textarea(rows='10', v-model='textInput')


        .column.is-tablet-4
          h4 {{$t('keywords')}}
          .wordCounter-keywords
            template( v-if="textInput.length")
              p(v-for='(word, index) in uniqueWords' :key='index')
                | {{word.word}} : {{word.amount}} ({{((word.amount / words.length) * 100).toFixed(2)}} %)
            p(v-else) {{$t('keywordsEmpty')}}



  .u-mb-md

</template>

<script>
export default {
  meta: {
    logoText: 'wordCounter'
  },
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  data: () => ({
    textInput: '',
    whitespaces: 0
  }),
  methods: {},
  computed: {
    words() {
      return this.textInput.match(/\b[-?(\w+)?]+\b/gi);
    },
    uniqueWords() {
      if (!this.words) return;
      return this.words
        .reduce(
          (map => (r, a) => (!map.has(a) && map.set(a, r[r.push({ word: a, amount: 0 }) - 1]), map.get(a).amount++, r))(
            new Map()
          ),
          []
        )
        .sort((a, b) => b.amount - a.amount);
    },
    paragraphs() {
      let _paragraphs = this.textInput.replace(/\n$/gm, '').split(/\n/);
      if (_paragraphs[0] == false) {
        return [];
      } else return _paragraphs;
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Word counter",
    "pageDesc":"Word counter is Baianat tool designed to help content creators and marketers write more optimized content.",
    "mantra":"Count and optimize |your writing.",
    "characters":"Characters",
    "words":"Words",
    "sentences":"Sentences",
    "whiteSpaces":"White Spaces",
    "paragraphs":"Paragraphs",
    "readingTime":"Reading time",
    "facebook":"Facebook",
    "twitter":"Twitter",
    "keywords":"Keywords",
    "keywordsEmpty":"Enter text to display keywords"
  },
  "ar": {
    "pageTitle":"حساب عدد الكلمات",
    "pageDesc":"حساب عدد الكلمات هي أداة من بيانات مصممة لمساعدة منشئي المحتوى والمسوقين أثناء كتابة المحتوى الخاص بهم ليكون محسنًا أكثر.",
    "mantra":"احسب عدد الكلمات |وحسن كتاباتك.",
    "characters":"الحروف",
    "words":"الكلمات",
    "sentences":"الجمل",
    "whiteSpaces":"المسافات",
    "paragraphs":"الفقرات",
    "readingTime":"وقت القراءة",
    "facebook":"فيسبوك",
    "twitter":"تويتر",
    "keywords":"الكلمات الدالة",
    "keywordsEmpty":"أدخل النص لعرض الكلمات الرئيسية"

  }
}
</i18n>

<style lang="stylus">
.wordCounter
  &-header
    display: flex
    justify-content: space-between
    flex-wrap: wrap

    >*
      margin-right: 40px
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column

      >span
        font-size: 20px

      >b
        font-size: 30px

.progressBar
  width: 200px
  border: 1px solid black
  display: inline-block
  padding: 1px

.progressBar > div
  background-color: blue
  height: 10px
  max-width: 100%
</style>
